import React, { useEffect, useState, useContext } from "react";
import Sidebar from "./Sidebar";
import MainHeader from "./MainHeader";
import axios from "axios";
import { Table, Container, Breadcrumb } from "react-bootstrap";
import ClusterOffcanvas from "./ClusterOffcanvas";
import ClusterImg from "./../images/Kubernetes-Services.svg";
import clusterAwsImg from "./../images/kubernetes.png";
import clusterGcpImg from "./../images/gke.png";
import Namespace from "./../images/namespace.png";
import { SlMagnifier } from "react-icons/sl";
import {
  BsCheckCircleFill,
  BsXCircleFill,
  BsHourglassSplit,
} from "react-icons/bs";
import { FaCube } from "react-icons/fa";
// import { VscEye } from "react-icons/vsc";
import { toast } from "react-toastify";
import WebSocketContext from "./../context/WebSocketContext";

const ClusterTreeView = () => {
  const [clusterData, setClusterData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [isNamespaceView, setIsNamespaceView] = useState(false);
  const [namespaceData, setNamespaceData] = useState([]);
  const [podsData, setPodsData] = useState([]);
  const [selectedNamespace, setSelectedNamespace] = useState(null);
  const [isPodsView, setIsPodsView] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { socketData } = useContext(WebSocketContext);
  const [loadingNamespace, setLoadingNamespace] = useState(null);
  const [loadingCluster, setLoadingCluster] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [hoveredType, setHoveredType] = useState(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const provider = localStorage.getItem("provider");

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const providerLower = provider?.toLowerCase();

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };
  const handleShowModal = (cluster) => {
    setSelectedCluster(cluster); // Store selected cluster details
    setShowModal(true); // Open modal
  };

  useEffect(() => {
    const fetchClusters = async () => {
      setLoadingCluster(true);
      try {
        const response = await axios.get(
          `${
            process.env.REACT_APP_API_BASE_URL
          }/container/${provider?.toLowerCase()}/clusters`
        );
        const clusterData = response?.data?.data?.data;
        setClusterData(clusterData);       
      } catch (error) {
        console.error("Error fetching clusters:", error);
      } finally {
        setLoadingCluster(false);
      }
    };

    fetchClusters();
    // eslint-disable-next-line
  }, []);

  const fetchNamespaces = async () => {
    if (!selectedCluster) return;

    try {
      let clusterParam = `clusterId=${encodeURIComponent(selectedCluster?.id)}`;

      // If provider is AWS, use name instead of id and add region
      if (providerLower === "aws" || providerLower === "gcp") {
        clusterParam = `clusterId=${selectedCluster?.name}`;
        const region = selectedCluster?.location;
        clusterParam += `&region=${region}`;
      }
      if (providerLower === "gcp") {
        const projectId = selectedCluster?.cloudAccountId
        clusterParam += `&projectId=${projectId}`;
      }

      const url = `${baseUrl}/container/${providerLower}/namespaces?${clusterParam}`;

      const response = await axios.get(url);

      setNamespaceData(response?.data?.data?.namespacesList || []);
      setIsNamespaceView(true); // Switch to namespace view
      setShowModal(false); // Close modal after clicking "Namespaces"
    } catch (error) {
      console.error("Error fetching namespaces:", error);
      toast.warning(
        `Reminder: You must change ${selectedCluster.name}'s status to 'Start'`,
        { position: "top-right" }
      );
    }
  };

  // const fetchPodsData = async (namespace) => {
  //   if (!selectedCluster || !namespace) return;
  //   setLoadingNamespace(namespace.name);
  //   try {
  //     let namespaceParam = `clusterId=${encodeURIComponent(
  //       selectedCluster?.id
  //     )}&namespaces=${namespace.name}`;

  //     // If provider is AWS, use name instead of id and add region
  //     if (providerLower === "aws") {
  //       namespaceParam = `clusterId=${selectedCluster?.name}&namespaces=${namespace.name}`;
  //       const region = selectedCluster?.location;
  //       namespaceParam += `&region=${region}`;
  //     }

  //     const url = `${baseUrl}/container/${providerLower}/pods?${namespaceParam}`;

  //     const response = await axios.get(url);

  //     const pods = response?.data?.data?.podsListByNamespaces[0]?.pods || [];
  //     setLoadingNamespace(null);
  //     if (pods.length === 0) {
  //       toast.warning(
  //         `No pods are currently available in ${namespace?.name}.`,
  //         { position: "top-right" }
  //       );
  //       return; // Do not navigate if no pods exist
  //     }
  //     setSelectedNamespace(namespace);
  //     setPodsData(pods);
  //     setIsPodsView(true);
  //   } catch (error) {
  //     console.error("Error fetching pods:", error);
  //   }
  // };

  const fetchPodsData = async (namespace) => {
    if (!selectedCluster || !namespace) return;

    setLoadingNamespace(namespace.name);

    try {
      let namespaceParam = `clusterId=${encodeURIComponent(
        selectedCluster?.id
      )}&namespaces=${namespace.name}`;

      // Adjust parameters for AWS
      if (providerLower === "aws" || providerLower === "gcp") {
        namespaceParam = `clusterId=${selectedCluster?.name}&namespaces=${namespace.name}`;
        const region = selectedCluster?.location;
        namespaceParam += `&region=${region}`;
      }
      if (providerLower === "gcp") {
        const projectId = selectedCluster?.cloudAccountId
        namespaceParam += `&projectId=${projectId}`;
      }

      const podsUrl = `${baseUrl}/container/${providerLower}/pods?${namespaceParam}`;
      const podsResponse = await axios.get(podsUrl);
      let pods = podsResponse?.data?.data?.podsListByNamespaces[0]?.pods || [];

      if (pods.length === 0) {
        setLoadingNamespace(null);
        toast.warning(
          `No pods are currently available in ${namespace?.name}.`,
          { position: "top-right" }
        );
        return;
      }

      // Additional CPU/Memory usage call for Azure
        const region = (providerLower === "aws" || providerLower === "gcp") ? `&region=${selectedCluster?.location}` : "";
        const projectId = (providerLower === "gcp") ? `&projectId=${selectedCluster?.cloudAccountId}` : "";
        const isClusterIdName = providerLower === "azure" ? encodeURIComponent(selectedCluster?.id) : selectedCluster?.name
        const metricsUrl = `${baseUrl}/container/${providerLower}/pods-metrics?clusterId=${isClusterIdName}&namespace=${namespace.name}${region}${projectId}`;
        const metricsResponse = await axios.get(metricsUrl);
        const metricsList = metricsResponse?.data?.data || [];

        // Merge CPU/Memory metrics with pod list by pod name
        pods = pods.map((pod) => {
          const matchingMetric = metricsList.find(
            (metric) => metric?.podName === pod?.name
          );
          return {
            ...pod,
            cpuUsage: matchingMetric?.cpuUsage || null,
            cpuRequest: matchingMetric?.cpuRequest || null,
            cpuLimit: matchingMetric?.cpuLimit || null,
            cpuUtilization: matchingMetric?.cpuUtilization || null,
            memoryUsage: matchingMetric?.memoryUsage || null,
            memoryRequest: matchingMetric?.memoryRequest || null,
            memoryLimit: matchingMetric?.memoryLimit || null,
            memoryUtilization: matchingMetric?.memoryUtilization || null,
          };
        });
        console.log(pods, "pods");

      setLoadingNamespace(null);
      setSelectedNamespace(namespace);
      setPodsData(pods); // Pods now contain CPU/Memory info if Azure
      setIsPodsView(true);
    } catch (error) {
      console.error("Error fetching pods or metrics:", error);
      setLoadingNamespace(null);
    }
  };

  const handleBack = () => {
    if (isPodsView) {
      setIsPodsView(false); // Go back to namespaces
    } else {
      setIsNamespaceView(false); // Go back to clusters
    }
  };

  const handleHome = () => {
    setIsPodsView(false);
    setIsNamespaceView(false);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter clusters based on searchTerm
  const filteredClusters = clusterData?.filter((data) =>
    data?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Filter namespaces based on searchTerm
  const filteredNamespaces = namespaceData.filter((ns) =>
    ns?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Filter pods based on searchTerm
  const filteredPods = podsData.filter((pod) =>
    pod?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  console.log(JSON.stringify(socketData), "socketData");
  console.log(socketData, "socketDataObject");

  const updateStateBasedOnSocket = (socketData) => {
    if (!socketData?.data) return;

    const { topic, data } = socketData;
    const newReplicationRow = data?.appEventTypeDetail?.action;

    const topicResourceName = topic?.toLowerCase();

    const updatedData = clusterData.map((item) => {
      if (item?.id?.toLowerCase() === topicResourceName) {
        return {
          ...item,
          state: newReplicationRow,
        };
      }
      return item; // Ensure that the original item is returned if the condition is false
    });
    setClusterData(updatedData);
  };

  useEffect(() => {
    updateStateBasedOnSocket(socketData);
    // eslint-disable-next-line
  }, [socketData]);

  return (
    <>
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className={`content p-5 ${
          isSidebarOpen ? "content-expanded" : "content-collapsed"
        }`}
      >
        <MainHeader />
        <Container fluid className="mt-4">
          <div className="d-flex align-items-center justify-content-between">
            <div className="mt-2">
              {isPodsView || isNamespaceView ? (
                <Breadcrumb className="fs-5 ms-2">
                  <Breadcrumb.Item
                    onClick={isPodsView ? handleHome : handleBack}
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                  >
                    {selectedCluster.name}
                  </Breadcrumb.Item>

                  {isPodsView && isNamespaceView ? (
                    <>
                      <Breadcrumb.Item
                        onClick={handleBack}
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        {selectedNamespace.name}
                      </Breadcrumb.Item>
                    </>
                  ) : null}

                  <Breadcrumb.Item active>
                    {isPodsView ? "Pods" : "Namespaces"}
                  </Breadcrumb.Item>
                </Breadcrumb>
              ) : (
                <h4 className="fw-bold ms-2">Clusters</h4>
              )}
            </div>
            <div className="input-group w-50">
              <input
                value={searchTerm}
                onChange={handleSearchChange}
                type="text"
                placeholder="Search ..."
                className="form-control"
              />
              <div className="input-group-append">
                <span className="input-group-text h-100">
                  <SlMagnifier />
                </span>
              </div>
            </div>
          </div>
          {isPodsView ? (
            <>
              <div className="card rounded-lg border mt-3 table-wrapper">
                <div className="card-body">
                  <Table className="table table-alter">
                    <thead className="fw-bold tablebg">
                      <tr>
                        <th
                          rowSpan="2"
                          className="text-uppercase tablebgtext border border-dark"
                        >
                          Name
                        </th>
                        <th
                          colSpan="2"
                          className="text-uppercase tablebgtext border border-dark text-center"
                        >
                          <span className="me-5">Utilization</span>
                        </th>
                        <th
                          rowSpan="2"
                          className="text-uppercase tablebgtext border border-dark"
                        >
                          Node
                        </th>
                        <th
                          rowSpan="2"
                          className="text-uppercase tablebgtext border border-dark"
                        >
                          Status
                        </th>
                        <th
                          rowSpan="2"
                          className="text-uppercase tablebgtext border border-dark"
                        >
                          Created At
                        </th>
                      </tr>
                      <tr className="tablebg">
                        <th className="tablebgtext border-top border border-dark">
                          CPU
                        </th>
                        <th className="tablebgtext border-top border border-dark">
                          Memory
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredPods.map((pod, index) => (
                        <tr key={index}>
                          <td className="text-start text-dark border-0">
                            {" "}
                            <FaCube style={{ color: "#855dcd" }} /> {pod?.name}
                          </td>
                          <td className="text-dark border-0 position-relative">
                            <span
                              onMouseEnter={() => {
                                setHoveredRow(index);
                                setHoveredType("cpu");
                              }}
                              onMouseLeave={() => {
                                setHoveredRow(null);
                                setHoveredType(null);
                              }}
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                zIndex: 1,
                              }}
                            >
                              <i className="fas fa-microchip me-1 text-primary"></i>
                            </span>
                            {pod?.cpuUtilization || "-"}

                            {hoveredRow === index && hoveredType === "cpu" && (
                              <div
                                className="position-absolute bg-white shadow p-2 rounded border"
                                style={{
                                  top: "-70px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  zIndex: 9999,
                                  whiteSpace: "nowrap",
                                  fontSize: "0.75rem",
                                  width: "200px",
                                }}
                              >
                                <strong>CPU Usage:</strong>{" "}
                                {pod?.cpuUsage || "-"} <br />
                                <strong>CPU Requests:</strong>{" "}
                                {pod?.cpuRequest || "-"} <br />
                                <strong>CPU Limits:</strong>{" "}
                                {pod?.cpuLimit || "-"}
                              </div>
                            )}
                          </td>

                          <td className="text-dark border-0 position-relative">
                            <span
                              onMouseEnter={() => {
                                setHoveredRow(index);
                                setHoveredType("memory");
                              }}
                              onMouseLeave={() => {
                                setHoveredRow(null);
                                setHoveredType(null);
                              }}
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                zIndex: 1,
                              }}
                            >
                              <i className="fas fa-memory me-1 text-warning"></i>
                            </span>
                            {pod?.memoryUtilization || "-"}

                            {hoveredRow === index &&
                              hoveredType === "memory" && (
                                <div
                                  className="position-absolute bg-white shadow p-2 rounded border"
                                  style={{
                                    top: "-70px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    zIndex: 10,
                                    whiteSpace: "nowrap",
                                    fontSize: "0.75rem",
                                    width: "200px",
                                  }}
                                >
                                  <strong>Memory Usage:</strong>{" "}
                                  {pod?.memoryUsage || "-"} <br />
                                  <strong>Memory Requests:</strong>{" "}
                                  {pod?.memoryRequest || "-"} <br />
                                  <strong>Memory Limits:</strong>{" "}
                                  {pod?.memoryLimit || "-"}
                                </div>
                              )}
                          </td>

                          <td className="text-dark border-0">{pod?.node}</td>
                          <td className="text-dark border-0">
                            {pod?.status === "Running" ? (
                              <BsCheckCircleFill
                                className="text-success"
                                size={15}
                              />
                            ) : pod?.status === "Pending" ? (
                              <BsHourglassSplit
                                className="text-warning"
                                size={15}
                              />
                            ) : (
                              <BsXCircleFill
                                className="text-danger"
                                size={15}
                              />
                            )}
                            <span className="ms-1">{pod?.status}</span>
                          </td>
                          <td className="text-dark border-0">
                            {pod?.createdAt}
                          </td>  
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </>
          ) : isNamespaceView ? (
            <>
              <div className="card rounded-lg border mt-3">
                <div className="card-body">
                  <Table className="table table-alter table-hover">
                    <thead className="fw-bold tablebg">
                      <tr>
                        <th className="text-uppercase tablebgtext border-top border-bottom">
                          Name
                        </th>
                        <th className="text-uppercase tablebgtext border-top border-bottom">
                          Status
                        </th>
                        <th className="text-uppercase tablebgtext border-top border-bottom">
                          Created At
                        </th>
                        {/* <th className="text-uppercase tablebgtext border-top border-bottom">
                          Pods
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredNamespaces.map((ns, index) => {
                        const isLoading = loadingNamespace === ns.name;

                        return (
                          <tr
                            key={index}
                            onClick={() => fetchPodsData(ns)}
                            style={{
                              cursor: "pointer",
                              opacity: isLoading ? 0.5 : 1,
                              position: "relative",
                            }}
                          >
                            <td className="text-dark border-0">
                              <img
                                src={Namespace}
                                alt="namespace"
                                style={{ width: "20px", height: "20px" }}
                              />{" "}
                              {ns?.name}
                            </td>
                            <td className="text-dark border-0">
                              {ns.status || "-"}
                            </td>
                            <td className="text-dark border-0">
                              {ns.createdAt}
                            </td>

                            {/* Loader overlay (absolutely positioned within row) */}
                            {isLoading && (
                              <td
                                colSpan={3}
                                style={{
                                  position: "absolute",
                                  left: 0,
                                  top: 0,
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  background: "rgba(255, 255, 255, 0.6)",
                                  zIndex: 1,
                                  pointerEvents: "none",
                                }}
                              >
                                <div
                                  className="spinner-border text-dark"
                                  role="status"
                                />
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="card rounded-lg border mt-3">
                <div className="card-body">
                  <div className="table-responsive">
                    {loadingCluster ? (
                      <div className="d-flex justify-content-center my-4">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <table className="table table-alter table-hover">
                        <thead className="fw-bold tablebg">
                          <tr>
                            <th className="text-uppercase tablebgtext border-top border-bottom">
                              Name
                            </th>
                            <th className="text-uppercase tablebgtext border-top border-bottom">
                              Location
                            </th>
                            <th className="text-uppercase tablebgtext border-top border-bottom">
                              Status
                            </th>
                            <th className="text-uppercase tablebgtext border-top border-bottom">
                              Project Name
                            </th>
                            <th className="text-uppercase tablebgtext border-top border-bottom">
                              Kubernetes Version
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredClusters?.length > 0 ? (
                            filteredClusters?.map((data, index) => (
                              <tr
                                key={index}
                                onClick={() => handleShowModal(data)}
                                style={{ cursor: "pointer" }}
                              >
                                <td className="text-dark border-0">
                                  <img
                                    src={
                                      provider?.toLowerCase() === "azure"
                                        ? ClusterImg
                                        :  provider?.toLowerCase() === "aws" ? clusterAwsImg : clusterGcpImg
                                    }
                                    alt="cluster"
                                    style={{ width: "20px", height: "20px" }}
                                  />{" "}
                                  <span className="ms-1">{data?.name}</span>
                                </td>
                                <td className="text-dark border-0">
                                  {data?.location}
                                </td>
                                <td className="text-dark border-0">
                                  {data?.state?.toLowerCase() === "running" ||
                                  data?.state?.toLowerCase() === "active" ? (
                                    <BsCheckCircleFill
                                      className="text-success-cl"
                                      size={15}
                                    />
                                  ) : (
                                    <BsXCircleFill
                                      className="text-danger"
                                      size={15}
                                    />
                                  )}
                                  <span className="ms-1">{data?.state}</span>
                                </td>
                                <td className="text-dark border-0">
                                  {data?.projectName}
                                </td>
                                <td className="text-dark border-0">
                                  {data?.kubernetesVersion}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </Container>
      </div>
      <ClusterOffcanvas
        show={showModal}
        handleClose={() => setShowModal(false)}
        onNamespaceClick={fetchNamespaces} // Fetch only on "Namespaces" click
        selectedCluster={selectedCluster}
      />
    </>
  );
};

export default ClusterTreeView;
